import React from 'react';
import Content from '@/pages/operate-platform/components/report-process/components/content-group/content';

export default function ContentGroup(props) {
  const { key, data, cardNumber, dataSource } = props;
  return (
    <div key={key} className="report-process-swiper-content">
      {data.map((item, key) => {
        if (item) {
          return <Content data={item} key={key} width={100 / cardNumber + '%'} dataSource={dataSource} />;
        } else {
          return (
            <div
              className="report-process-wrapper report-process-temp"
              key={key}
              style={{ width: 100 / cardNumber + '%' }}
            />
          );
        }
      })}
    </div>
  );
}
